import { Component, h } from "preact"
import PageDataFeed from "../../../../services/page-data-feed"
import useEmblaCarousel from "embla-carousel-react"
import Autoplay from "embla-carousel-autoplay"
import Config from "../../config";
import { CasinoSlide } from "./logic";


export class Carousel extends Component<{}, { slides?: CasinoSlide[] }> {
    componentWillMount() {
        PageDataFeed.getCarousel().then(data => {
            this.setState({ slides: data['casino-promo'] })
        })
    }

    render() {
        if (this.state.slides == null)
            return;

        const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: 'center', containScroll:'keepSnaps' })

        // .embla DEVE essere position:relative

        return (
            <div class="h-[265px] w-full overflow-x-hidden bg-blue-whale-950">
                <div class="embla h-full relative" ref={emblaRef}>
                    <div class="embla__container h-full will-change-transform">
                        {this.state.slides.map(slide => (<div class="flex-none w-full max-w-[1400px]">
                            <div class="relative h-full w-full">
                                <img src={Config.softionAPI + slide.img} class="h-full w-full object-cover" loading="lazy" />
                                <div class="absolute top-1/3 text-white drop-shadow-xl text-3xl right-4">
                                    <div class="text-5xl">{slide.title}</div>
                                    <div class="text-3xl">{slide.subtitle}</div>
                                </div>
                            </div>
                        </div>))}
                    </div>
                </div>
            </div>
        )
    }
}